<script>
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import HandlesBackendValidationErrors from '@/mixins/HandlesBackendValidationErrors'
import FeatureTextarea from '@/components/cars/edit/FeatureTextarea.vue'
import { createDeletionRequest } from '@/api/cars'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-feature-textarea': FeatureTextarea,
    'mia-submit-button': SubmitButton
  },

  mixins: [HandlesBackendValidationErrors],

  props: {
    carId: {
      type: [String, Number],
      required: true
    }
  },

  data: () => ({
    form: {
      item_comment: ''
    }
  }),

  methods: {
    reset() {
      this.$set(this.form, 'item_comment', '')
    },

    onCancel() {
      this.$emit('closed')
    },

    async onSubmit() {
      this.$wait.start('requesting trash car')
      const [error] = await createDeletionRequest(this.carId, this.form)
      this.$wait.end('requesting trash car')

      if (error) {
        this.handleBackendValidationErrors(error)
        window.eventBus.$emit('mia-error', {
          error: ['Die Löschanfrage konnte nicht erstellt werden.']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Die Löschanfrage wurde erfolgreich erstellt.']
      })
      this.reset()
      this.$emit('closed')
    },

    onOpened() {
      this.$refs.commentInputRef.focus()
    }
  }
}
</script>

<template>
  <mia-modal
    id="request-trash-car-modal"
    classes="v--modal flex flex-col"
    width="40%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
    @opened="onOpened"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Löschanfrage erstellen
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <mia-feature-textarea
        ref="commentInputRef"
        v-model="form.item_comment"
        label="Bemerkung"
        :errors="getErrors('item_comment')"
        required
        @input="clearErrors('item_comment')"
      />
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Abbrechen"
        type="button"
        :disabled="$wait.any"
        size="small"
        @click="onCancel"
      />

      <mia-submit-button
        label="Löschanfrage erstellen"
        type="button"
        class="ml-3"
        :disabled="$wait.any"
        :is-loading="$wait.is('requesting trash car')"
        size="small"
        @click="onSubmit"
      />
    </mia-modal-footer>
  </mia-modal>
</template>
